<template>
  <div>

 <div style="height: 100vh;overflow: scroll;padding: 15px;padding-top:29px">

   
  <div>
 


<template v-for='cat in categories'>
 
<div class="pb-3 ">
  <div class="d-flex align-items-center justify-content-between">
    <h2 style="font-size: 16px;
    color: #313131;
    font-weight: 600;">{{cat}}</h2>
         <router-link :to="  '/categories/'+cat" style='text-decoration:none'>

    <i class="material-icons" style="color:#212529">arrow_forward</i>
</router-link>

    
  </div>
  </div>  



 
    <div class="d-flex align-items-start flex-nowrap ovescro" style="margin: 0 -15px;padding-left: 15px;overflow: scroll;">
        <template  v-for='(item,key) in x[cat]' >

             <div v-bind:class="[{ mleft:  key==0 },{ mnleft: !(key==0) },{prodlist:true}]" 
>
        <div>

        <img :src="item.imageurl" class="img-fluid"  style="border-radius: 4px;">
        </div>
        <div style="margin: 5px 0 ">
          <p class="nametxt p1" >{{item.name}}</p>
          <p class="nametxt p2" style="">{{item.price}} / mo</p>
        </div>
        
      </div>
          
        </template>
   
<router-link :to="'/categories/'+cat" style='text-decoration:none'>

      
      <div style="padding-right: 15px">
      <div class="prodlist" style=" min-width: 88px;background: #7e9c9a;border-radius: 4px;margin-left: 12px">
       <div style="padding-bottom: 100%;position: relative;" >
          <div style="position: absolute;top: 0;left: 0;right: 0;bottom: 0" class="d-flex align-items-center justify-content-center">
              <span style="font-size: 10px;text-transform: uppercase;color: #fff">View more</span>
          </div>
 
        
       </div>
       
      </div> 
    </div>
  </router-link>
    
    
       
       
    </div>
</template>

 

 
 
  
<div style="height:35px"></div>
</div>
 
    
  

  
</div>
 



  </div>
</template>

<script>
 
 
export default {
 
     props: ['loadstatus','products','category','theme' ],

  data () {

        return{

              x:{



              },
              categories:[],
              ss:''

        }
     
    
  },
  created(){

 
this.categories=[]
 for (var key in this.category) {



    if (this.category.hasOwnProperty(key)) {
      
        console.log(key + " -> " + this.category[key].name);
        if(!this.categories.includes(this.category[key].name)){
           this.categories.push(this.category[key].name)
             this.x[this.category[key].name]=[]

        }
       
    }


}

this.products.map((item)=>{

if(this.categories.includes(item.category))
{

  this.x[item.category].push(item)
}

})
 
  

   },
   computed:{
 

    

   }

   
    
 
  
}
</script>
<style  scoped>
 .mnleft{
  margin-left:12px
 }
 .nametxt{
  font-size: 10px;
    color: #313131;
 
    margin: 5px 0;font-weight: 400;
 }
 
 .nametxt.p1{
  color: #313131;margin:0;   text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
 }
 .nametxt.p2{
  color: #bababa;margin:0;

 }
 .prodlist{
  min-width:87px;
  max-width:87px
 }
 .ovescro::-webkit-scrollbar { width: 0 !important }

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}
 
</style>
 



// WEBPACK FOOTER //
// src/category.vue